import React, { useState } from 'react';
import { Submission } from '../../submission-graphql';
import { releaseSubmission } from '../../Mutations/release-submission-mutation';
import { GraphQLError } from '../../../../../../../common/components/ApolloError/GraphQLError';
import { ApolloError } from '@apollo/client';
import { StyledButton } from '../../../../../../../common/Styleguide/Common/Button';

interface ReleaseSubmissionButtonProps {
  submission: Submission;
}

const ReleaseSubmissionButton = (props: ReleaseSubmissionButtonProps) => {
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState<Error | ApolloError | undefined>();

  const onClick = async () => {
    try {
      setInProgress(true);
      await releaseSubmission({ id: props.submission.id });
      setInProgress(false);
    } catch (e) {
      setError(e as Error);
    }
  };

  return (
    <>
      <StyledButton
        sx={{
          borderRadius: '8px',
          width: '100%',
        }}
        variant="contained"
        onClick={onClick}
        disabled={inProgress}
      >
        Release Changes
      </StyledButton>
      <GraphQLError error={error} />
    </>
  );
};

export default ReleaseSubmissionButton;
